module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-4-selected.778a6460.png";